/**
 * Configuration Settings documentation page
 */

import {DocsContent} from '../../../components/docs/DocsContent';
import {DocsActionButtons} from '../../../components/docs/DocsActionButtons';

export function ConfigurationSettings() {
  return (
    <DocsContent
      title="Settings"
      description="Configure VoxaPilot to match your preferences and requirements."
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">General Settings</h2>
          <p className="text-textSecondary mb-4">
            Configure general preferences for your VoxaPilot account.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Transcription Settings</h2>
          <ul className="list-disc list-inside space-y-2 text-textSecondary mb-6">
            <li>Default transcription language</li>
            <li>Auto-transcribe all meetings</li>
            <li>Real-time transcription preferences</li>
            <li>Speaker detection settings</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Summary Settings</h2>
          <ul className="list-disc list-inside space-y-2 text-textSecondary mb-6">
            <li>Default summary length</li>
            <li>Auto-generate summaries</li>
            <li>Summary sharing preferences</li>
            <li>AI model selection</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Privacy & Security</h2>
          <ul className="list-disc list-inside space-y-2 text-textSecondary mb-6">
            <li>Data retention policies</li>
            <li>Sharing permissions</li>
            <li>Export settings</li>
            <li>API key management</li>
          </ul>
        </section>

        <DocsActionButtons pageTitle="Settings" />
      </div>
    </DocsContent>
  );
}

